import image1 from 'images/vegatables/vegetable-1.jpg';
import image2 from 'images/vegatables/vegetable-2.jpg';
import image3 from 'images/vegatables/vegetable-3.jpg';
import image4 from 'images/vegatables/vegetable-4.jpg';
import image5 from 'images/vegatables/vegetable-5.jpg';
import image6 from 'images/vegatables/vegetable-6.jpg';
import image7 from 'images/vegatables/vegetable-7.jpg';
import image8 from 'images/vegatables/vegetable-8.jpg';
import bottle from 'images/product-bottle.jpg';

export const products = [
    { name: 'Wuxal Р Мах', img: bottle },
    { name: 'Wuxal Universal Active', img: bottle },
    { name: 'Wuxal MacroMix', img: bottle },
    { name: 'Wuxal Boron pH', img: bottle },
    { name: 'Wuxal Oilseed PLUS', img: bottle },
    { name: 'Wuxal CalciBor', img: bottle },
    { name: 'Wuxal Combi PLUS', img: bottle },
    { name: 'Wuxal Microplant', img: bottle },
];

export const vegatables = [
    { name: 'Cereals', img: image2 },
    { name: 'Corn', img: image1 },
    { name: 'Sunflower', img: image8 },
    { name: 'Pulses (soybeans, peas)', img: image7 },
    { name: 'Winter rape', img: image6 },
    { name: 'Sugar beet', img: image5 },
    { name: 'Cabbage', img: image4 },
    { name: 'Potatoes', img: image3 },
];

export const vegatables2 = [
    { name: 'Corn', img: image1 },
    { name: 'Sunflower', img: image8 },
    { name: 'Winter rape', img: image6 },
    { name: 'Cabbage', img: image4 },
    { name: 'Potatoes', img: image3 },
    { name: 'Cereals', img: image2 },
    { name: 'Sugar beet', img: image5 },
    { name: 'Pulses (soybeans, peas)', img: image7 },
];
